import { render, staticRenderFns } from "./ContractDetails.vue?vue&type=template&id=0cabb95a&scoped=true"
import script from "./ContractDetails.vue?vue&type=script&lang=js"
export * from "./ContractDetails.vue?vue&type=script&lang=js"
import style0 from "./ContractDetails.vue?vue&type=style&index=0&id=0cabb95a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cabb95a",
  null
  
)

export default component.exports